<template>
  <!-- 设置单个三级分类坑位 -->
  <el-dialog
    title="设置坑位"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    class="dialog"
    center
  >
    <div class="d-flex a-center mb-15 mt-20" style="justify-content: center">
      <div class="mr10">{{ detailInfo.name }}</div>
      <div style="width: 200px">
        <el-input
          placeholder="请输入"
          v-model="detailInfo.slot"
          @blur="
            () =>
              (detailInfo.slot =
                detailInfo.slot == 0
                  ? ''
                  : tool.filterUnNumber(detailInfo.slot))
          "
        >
        </el-input>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onHandleSubmit"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import tool from "@/utils/tools/tool";
import { postCategoriesTagSlotSave } from "@/api/generalControl/category";
export default {
  name: "set-three-pit",
  components: {},
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      tool,
      detailInfo: {},
      logistic_business_id: "",
    };
  },
  computed: {},
  methods: {
    onInitData(e, lId) {
      console.log(e, "e==");
      this.detailInfo = JSON.parse(JSON.stringify(e));
      this.logistic_business_id = lId;
      this.dialogVisible = true;
    },
    onHandleClose() {
      this.dialogVisible = false;
    },
    async onHandleSubmit() {
      this.submitLoading = true;
      let tmpTag = [
        {
          tag_id: this.detailInfo.id,
          slot: this.detailInfo.slot,
        },
      ];
      try {
        const res = await postCategoriesTagSlotSave({
          tag_list: tmpTag,
          logistic_business_id: this.logistic_business_id,
        });
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.submitLoading = false;
        this.dialogVisible = false;
        this.$emit("submit");
      } catch (error) {
        console.log(error, "postCategoriesTagSlotSave");
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
